import type { IToast } from '@/types/components';
import { useCustomEvent } from '@/composables';
import { REQUEST_CANCELED_ERROR } from '@/api/httpHelper';
const { sendEvent } = useCustomEvent();

const toast = ({ type = 'error', title = '', content, duration = 5 }:IToast) => {
  // İptal edilen istekler (aynı istek yenisiyle değiştirildiğinde) kullanıcıya hata olarak gösterilmez.
  if (content === REQUEST_CANCELED_ERROR) return;
  const toastData = { type, title, content, duration };
  sendEvent('pushToast', toastData);
};

export default toast;